"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewNavigationCard = ReviewNavigationCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const client_1 = require("@kalkulacka-one/design-system/client");
const next_intl_1 = require("next-intl");
const navigation_card_1 = require("./navigation-card");
const HEIGHT = "koa:h-[88px]";
function ReviewNavigationCard({ onNextClick }) {
    const t = (0, next_intl_1.useTranslations)("koa.components.reviewNavigationCard");
    return ((0, jsx_runtime_1.jsx)(navigation_card_1.NavigationCard, { children: (0, jsx_runtime_1.jsx)(client_1.Button, { color: "neutral", onClick: onNextClick, children: t("showResultsButton") }) }));
}
ReviewNavigationCard.heightClassNames = HEIGHT;
